const cnaeMapping: Record<string, string> = {
  9_313_100: 'Academia',
  4_722_901: 'Açougue e/ou peixaria',
  4_722_902: 'Açougue e/ou peixaria',
  5_611_201: 'Bar e/ou restaurante',
  5_611_202: 'Bar e/ou restaurante',
  5_611_203: 'Bar e/ou restaurante',
  5_611_204: 'Bar e/ou restaurante',
  5_611_205: 'Bar e/ou restaurante',
  8_630_503: 'Clínica e/ou consultório',
  4_511_101: 'Comércio e/ou varejo',
  4_729_699: 'Comércio e/ou varejo',
  4_753_900: 'Comércio e/ou varejo',
  4_759_899: 'Comércio e/ou varejo',
  4_713_000: 'Comércio e/ou varejo',
  8_112_500: 'Condomínio',
  6_822_600: 'Condomínio',
  4_120_400: 'Construção civil',
  4_399_103: 'Construção civil',
  4_399_199: 'Construção civil',
  5_620_104: 'Delivery',
  8_511_200: 'Instituição de ensino',
  8_512_100: 'Instituição de ensino',
  8_513_900: 'Instituição de ensino',
  8_520_100: 'Instituição de ensino',
  8_531_700: 'Instituição de ensino',
  8_532_500: 'Instituição de ensino',
  8_541_400: 'Instituição de ensino',
  8_542_200: 'Instituição de ensino',
  8_599_699: 'Instituição de ensino',
  8_591_100: 'Instituição de ensino',
  8_593_700: 'Instituição de ensino',
  5_510_801: 'Hotel e/ou pousada',
  9_601_701: 'Lavanderia',
  5_250_804: 'Logística',
  8_299_706: 'Lotérica',
  4_520_001: 'Oficina mecânica',
  9_491_000: 'Organização religiosa',
  4_721_102: 'Padaria e/ou confeitaria',
  1_091_102: 'Padaria e/ou confeitaria',
  1_091_101: 'Padaria e/ou confeitaria',
  4_789_004: 'Pet Shop',
  9_609_208: 'Pet Shop',
  4_731_800: 'Posto de combustível',
  4_732_600: 'Posto de combustível',
  8_121_400: 'Serviços Gerais',
  8_129_000: 'Serviços Gerais',
  8_111_700: 'Serviços Gerais',
  7_490_104: 'Serviços Gerais',
  4_711_302: 'Supermercado',
  4_711_301: 'Supermercado',
  4_712_100: 'Supermercado',
};

export default function cnaeIdentifier(cnae: string): string {
  const normalizedCnae = cnae.replace(/\D/g, '');
  return cnaeMapping[normalizedCnae] || 'Outros';
}
